"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BackorderType = exports.ChartColor = exports.PayPeriod = void 0;
var PayPeriod;
(function (PayPeriod) {
    PayPeriod[PayPeriod["Daily"] = 1] = "Daily";
    PayPeriod[PayPeriod["Weekly"] = 2] = "Weekly";
    PayPeriod[PayPeriod["Monthly"] = 3] = "Monthly";
    PayPeriod[PayPeriod["Yearly"] = 4] = "Yearly";
})(PayPeriod = exports.PayPeriod || (exports.PayPeriod = {}));
var ChartColor;
(function (ChartColor) {
    ChartColor["Dispense"] = "#18c273";
    ChartColor["Order"] = "#9fbe22";
    ChartColor["Reimbursement"] = "#ffa600";
})(ChartColor = exports.ChartColor || (exports.ChartColor = {}));
var BackorderType;
(function (BackorderType) {
    BackorderType["Distributor"] = "distributor";
    BackorderType["Site"] = "site";
    BackorderType["SiteBackorder"] = "BO";
    BackorderType["SiteBackorderSubstitute"] = "BO Sub";
    BackorderType["Formulary"] = "formulary";
})(BackorderType = exports.BackorderType || (exports.BackorderType = {}));



//////////////////
// WEBPACK FOOTER
// ./src/shared/dashboard.ts
// module id = 2336
// module chunks = 0 1